import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/quickBetCard.css';
import QuickBetCardRacing from './quickBetCardRacing';
import QuickBetCardFootball from './quickBetCardFootball';
import {
    AMERICAN_FOOTBALL_MODULE,
    BASEBALL_MODULE,
    BASKETBALL_MODULE,
    CRICKET_MODULE,
    FOOTBALL_MODULE,
    MATCHDAY_MODULE,
    RACING_MODULE,
    RES,
    TENNIS_MODULE,
    VID
} from '../../../constants/identifiers';
import {getModuleFromEventType} from '../../../helpers/moduleHelpers';
import {ASSETS_URL} from "../../../constants/endpoints";
import QuickBetCardBasketball from "./quickBetCardBasketball";
import QuickBetCardAF from "./quickBetCardAF";
import {getGameFromChannel} from "../helpers/gameHelpers";
import {isMarbleEvent} from "../modules/racing/helpers/racersHelper";
import QuickBetCardMarbles from "./quickBetCardMarbles";
import {calculateTimeDifference, formatTimeInSecondsToS} from '../../../helpers/helperFunctions';
import {isMatchdayNMB, isTextBasedGame} from "../modules/matchday/helpers/matchdayHelper";
import eventLiveCounter from "./eventLiveCounter";
import QuickBetCardCricket from "./quickBetCardCricket";
import QuickBetCardTennis from "./quickBetCardTennis";
import QuickBetCardBaseball from "./quickBetCardBaseball";
import PreambleTextBasedMatchday from './preambleTextBasedMatchday';

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        serverTimeOffset: state.vpp.serverTimeOffset
    };
};

class QuickBetCard extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.isEventLive = false;
        this.state = {
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            timeLeft: this._getTimeLeft(),
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            serverTimeOffset: storeData.vpp.serverTimeOffset
        };
    }

    _getTimeLeft() {
        let nextEventTime = this._getNextEventTime();
        if (nextEventTime !== undefined) {
            let timeLeft = calculateTimeDifference(new Date(Date.now() - this.state.serverTimeOffset), nextEventTime) / 1000;
            if (Math.floor(timeLeft) === 0) {
                setTimeout(() => this.isEventLive = true, 200);
                setTimeout(() => this.isEventLive = false, 2000);
            }
            return timeLeft;
        }
        return undefined;
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: this._getTimeLeft()
        });
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    _getNextEventTime() {
        let eventTime;
        let event;
        if (this.state && this.state.nextEventsTimeStamp) {
            event = this.state.nextEventsTimeStamp.find((event) => event.channel === this.state.games[this.state.selectedGameIndex].channel && Number(event.eventTime) >= (new Date().getTime() - this.state.serverTimeOffset));
            if (event) {
                eventTime = Number(event.eventTime);
            }
        }
        return eventTime;
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset
            });
        }
    }

    render() {

        let store = this.props.store;
        let storeData = store.getState();

        let selectedEvent = (this.state.events && this.state.events.length && this.state.games[this.state.selectedGameIndex].channel === this.state.events[this.state.selectedEventIndex].channel)
            ? this.state.events[this.state.selectedEventIndex]
            : undefined;
        let gameCard;
        let channelName = this.state.games[this.state.selectedGameIndex].channel;

        if (storeData.vpp.nextEventsTimeStamp.find((event) => event.channel === storeData.vpp.games[this.state.selectedGameIndex].channel && Number(event.eventTime)) === undefined) {
            console.log('no future events');
            return '';
        }
        let backgroundImageUrl;
        if (selectedEvent) {
            let module = getModuleFromEventType(selectedEvent.eventType);

            switch (module) {
                case RACING_MODULE:
                    if (isMarbleEvent(selectedEvent.eventType)) {
                        gameCard = (<QuickBetCardMarbles id='quickBetCard_racingCard' store={this.props.store}/>);
                    } else {
                        gameCard = (<QuickBetCardRacing id='quickBetCard_racingCard' store={this.props.store}/>);
                    }
                    break;
                case FOOTBALL_MODULE:
                    gameCard = (<QuickBetCardFootball id='quickBetCard_footballCard' store={this.props.store}/>);
                    break;
                case BASKETBALL_MODULE:
                    gameCard = (<QuickBetCardBasketball id='quickBetCard_basketballCard' store={this.props.store}/>);
                    break;
                case AMERICAN_FOOTBALL_MODULE:
                    gameCard = (<QuickBetCardAF id='quickBetCard_basketballCard' store={this.props.store}/>);
                    break;
                case MATCHDAY_MODULE:
                    if (isTextBasedGame(channelName)){
                        gameCard = (<PreambleTextBasedMatchday id='preambleCard_matchday' store={this.props.store} />);
                    } else {
                        if (this.props.showCounter) {
                            gameCard = (
                                <div>{this.state.timeLeft !== undefined && !this.isEventLive ? eventLiveCounter(formatTimeInSecondsToS(this.state.timeLeft)) : ''}</div>)
                        } else {
                            let controllerState = this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex].controllerState;
                            if (controllerState !== undefined && controllerState[1] !== undefined && isMatchdayNMB(storeData)) {
                                let isLive = (controllerState[1] === VID || controllerState[1] === RES);
                                gameCard = (<div>{
                                        (isLive || this.isEventLive)
                                            ? ''
                                            : (this.state.timeLeft !== undefined && Math.floor(this.state.timeLeft) < 50)
                                                ? eventLiveCounter(formatTimeInSecondsToS(this.state.timeLeft))
                                                : ''}</div>);
                                }
                            }
                    }
                    break;
                case CRICKET_MODULE:
                    gameCard = (<QuickBetCardCricket id='quickBetCard_cricketCard' store={this.props.store}/>);
                    break;
                case TENNIS_MODULE:
                    gameCard = (<QuickBetCardTennis id='quickBetCard_tennis' store={this.props.store}/>);
                    break;
                case BASEBALL_MODULE:
                    gameCard = (<QuickBetCardBaseball id='quickBetCard_baseballCard' store={this.props.store}/>);
                    break;
                default:
                    gameCard = (<div></div>);
                    break;
            }
            backgroundImageUrl = `${ASSETS_URL}${getGameFromChannel(selectedEvent.channel, this.state.games).assetsPath}/backplate.png`;
        }
        return (
            <div className={style.mainContainer} style={{backgroundImage: `url(${backgroundImageUrl})`}}>
                {gameCard}
            </div>
        );
    }
}

export default connect(mapStateToProps)(QuickBetCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/quickBetCard.js